import { jsx as _jsx } from "react/jsx-runtime";
/**
 * MarkdownRenderer — rendu HTML pré-généré (build-time) pour les fiches
 * lore, pédagogie, science (Sprint 1.8).
 *
 * Le HTML provient toujours de `scripts/build-lore-data.mjs` qui sanitize
 * via rehype-sanitize. Aucune entrée utilisateur n'est jamais rendue ici.
 * `dangerouslySetInnerHTML` est donc safe — wikilinks et DOI links sont
 * post-traités côté build (résolution + target=_blank).
 *
 * Props :
 *   - html : HTML pré-généré (depuis data/{lore, pedagogie, science})
 *   - className : classes Tailwind du conteneur
 *   - onWikilinkClick : callback optionnel pour intercepter les <a class="wikilink">
 *     (par défaut : navigation react-router via Link interceptor)
 */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
export function MarkdownRenderer({ html, className }) {
    const navigate = useNavigate();
    const ref = useRef(null);
    // Intercepte clicks sur wikilinks pour navigation client-side react-router.
    // Les liens externes (target=_blank) ne sont pas interceptés.
    useEffect(() => {
        const node = ref.current;
        if (!node)
            return;
        const handler = (evt) => {
            const target = evt.target?.closest('a.wikilink');
            if (!target)
                return;
            const href = target.getAttribute('href');
            if (!href || href.startsWith('http'))
                return;
            evt.preventDefault();
            navigate(href);
        };
        node.addEventListener('click', handler);
        return () => node.removeEventListener('click', handler);
    }, [navigate, html]);
    return (_jsx("div", { ref: ref, className: className ?? 'lore-prose', 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: html } }));
}
//# sourceMappingURL=MarkdownRenderer.js.map